import React from "react";
import axios from "axios";
import Config from "../config/config";
import ExportUtils from './export';
import warningImg from '../img/warning.png';
import loader from '../img/loader.gif';
import closeSvg from '../img/close.svg';
import clear from '../img/clear.png';
import serarchSvg from '../img/search.png';
import download from '../img/download.png';
import sync from '../img/sync.png';
import sort from '../img/sort.png';
const { API_URL } = Config;

let reportType = '';

class Report extends React.Component {
  state = {
    showToast: false,
    message: '',
    searchK: "",
    reportData: [],
    loading: false,
    title: 'Help Topics',
    downloadBtnIsDisabled: false,
  };


  componentDidMount = () => {
    this.refreshList();
  }
  syncSheet = () => {
    var that = this;
    that.setState({ loading: true });
    axios
      .post(API_URL, {
        action: "sheets.sync"
      })
      .then(function (response) {
        console.log('syncSheetResponse', response);
        that.setState({ loading: false });
        if (response.data.status) {
          that.showToast(true, response.data.data)
        } else {
          that.showToast(true, response.data.errMsg)
        }
      })
      .catch(function (error) {
        that.setState({ loading: false });
        that.showToast(true, 'Something went wrong, please try again later')
      });
  }

  refreshList() {
    const { searchK } = this.state;
    var that = this;
    that.setState({ loading: true });
    axios.post(API_URL, {
      action: "sheets.getReports",
      data: {
        searchK: searchK,
        reportType
      }

    }).then(function (response) {
      console.log('refreshListResponse', response);
      that.setState({ loading: false });
      if (response.data.status) {
        var list = response.data.data ? response.data.data : [];
        that.setState({
          reportData: list
        });
      } else {
        console.log('Error==>', response.data.errMsg);
        that.showToast(true, response.data.errMsg)
      }

    }).catch(function (error) {
      that.setState({ loading: false });
      console.log(error);
      that.showToast(true, 'Something went wrong, please try again later')
    });
  }


  searchButton = () => {
    var that = this;
    const { searchK } = that.state;
    if (searchK === '') {
      that.showToast(true, 'Search is required field')
    } else {
      this.refreshList();
    }

  }

  clearFields = () => {
    var that = this;
    const { searchK } = that.state;
    if (searchK === '') {
      that.showToast(true, 'Search filed already empty')
    } else {
      this.setState({ searchK: "", loading: true })
      setTimeout(() => { this.refreshList(); }, 1000);
    }

  }

  showToast = (status, message) => {
    console.log(`showToast : ${status} ${message}`);
    this.setState({ showToast: status, message: message })
    setTimeout(() => {
      this.setState({ showToast: false, message: '' })
    }, 5000);
  }
  closeToast = () => {
    this.setState({ showToast: false, message: '' })
  }

  textChanged = (e) => {
    const that = this;
    console.log(e.target.value);
    const currentValue = e.target.value
    this.setState({
      searchK: currentValue
    })
    if (currentValue === '') {
      that.setState({ loading: true })
      setTimeout(() => { this.refreshList(); }, 1000);
    }
  }

  _handleKeyDown = (e) => {
    var that = this;
    if (e.key === 'Enter') {
      that.searchButton()
    }
  }

  reportTable = () => {
    const { reportData } = this.state;
    return <div className="table-container">
      <table id="reportTable">
        <thead >
          <tr>
            <th>Token</th>
            <th>Question</th>
            <th>This Day
              <img className="report-sort-icon"
                onClick={() => this.sortTable('#reportTable', '.item', 'td:nth-child(3)')}
                src={sort} alt=''
              />
            </th>
            <th>This Week
              <img className="report-sort-icon"
                onClick={() => this.sortTable('#reportTable', '.item', 'td:nth-child(4)')}
                src={sort} alt=''
              />
            </th>
            <th>This Month
              <img className="report-sort-icon"
                onClick={() => this.sortTable('#reportTable', '.item', 'td:nth-child(5)')}
                src={sort} alt=''
              />
            </th>
            <th>This Year
              <img className="report-sort-icon"
                onClick={() => this.sortTable('#reportTable', '.item', 'td:nth-child(6)')}
                src={sort} alt=''
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {
            reportData.map((aRow, index) => {
              return <tr key={index} className='item' >
                <td>{aRow.token}</td>
                <td className='report-table-question-max-width'>
                  {aRow.displayQ}
                </td>
                <td className='report-table-number-right-align'>
                  {aRow.dayRepeatcount ? aRow.dayRepeatcount : 0}
                </td>
                <td className='report-table-number-right-align'>
                  {aRow.weekRepeatcount ? aRow.weekRepeatcount : 0}
                </td>
                <td className='report-table-number-right-align'>
                  {aRow.monthRepeatcount ? aRow.monthRepeatcount : 0}
                </td>
                <td className='report-table-number-right-align'>
                  {aRow.repeatCount ? aRow.repeatCount : 0}
                </td>
              </tr>
            })
          }
        </tbody>
      </table>
    </div>
  }

  getElements = (id) => {
    if (typeof id == "object") {
      return [id];
    } else {
      return document.querySelectorAll(id);
    }
  };

  sortTable = (id, sel, sortvalue) => {
    var a, b, i, ii, y, bytt, v1, v2, cc, j;
    a = this.getElements(id);
    for (i = 0; i < a.length; i++) {
      for (j = 0; j < 2; j++) {
        cc = 0;
        y = 1;
        while (y == 1) {
          y = 0;
          b = a[i].querySelectorAll(sel);
          for (ii = 0; ii < (b.length - 1); ii++) {
            bytt = 0;
            if (sortvalue) {
              v1 = b[ii].querySelector(sortvalue).innerText;
              v2 = b[ii + 1].querySelector(sortvalue).innerText;
            } else {
              v1 = b[ii].innerText;
              v2 = b[ii + 1].innerText;
            }
            v1 = v1.toLowerCase();
            v2 = v2.toLowerCase();
            if ((j == 0 && (v1 > v2)) || (j == 1 && (v1 < v2))) {
              bytt = 1;
              break;
            }
          }
          if (bytt == 1) {
            b[ii].parentNode.insertBefore(b[ii + 1], b[ii]);
            y = 1;
            cc++;
          }
        }
        if (cc > 0) { break; }
      }
    }
  };

  downloadIntoExcle = () => {
    let that = this;
    const { reportData } = that.state;
    if (reportData.length > 0) {
      that.setState({ loading: true, downloadBtnIsDisabled: true })
      let reportArr = [];
      var counter = 0;
      let headers = [
        {
          key: "srno",
          text: "#"
        },
        {
          key: "token",
          text: "Token"
        },
        {
          key: "displayQ",
          text: "Question"
        },
        {
          key: "dayRepeatcount",
          text: "This Day"
        },
        {
          key: "weekRepeatcount",
          text: "This Week"
        },
        {
          key: "monthRepeatcount",
          text: "This Month"
        },
        {
          key: "repeatCount",
          text: "This Year"
        }
      ]
      for (let i = 0; i < reportData.length; i++) {
        counter++;
        const report = reportData[i];
        reportArr.push({
          "srno": counter,
          "token": report.token,
          "displayQ": report.displayQ,
          "dayRepeatcount": report.dayRepeatcount ? report.dayRepeatcount : 0,
          "weekRepeatcount": report.weekRepeatcount ? report.weekRepeatcount : 0,
          "monthRepeatcount": report.monthRepeatcount ? report.monthRepeatcount : 0,
          "repeatCount": report.repeatCount ? report.repeatCount : 0
        })
      }
      var htmlStr = ExportUtils.getTable(headers, reportArr);
      ExportUtils.tableToExcel(htmlStr, 'Report');
      setTimeout(() => {
        that.setState({ loading: false, downloadBtnIsDisabled: false })
      }, 2000);
    } else {
      that.showToast(true, 'Data is empty')
    }
  }

  reportFilterHandleChange = (e) => {
    let name = e.target.name ? e.target.name : '';
    console.log(`reportFilterHandleChange=> name: ${name}`);
    reportType = name;
    this.refreshList();
  }

  render() {
    const { loading, reportData, showToast, message, downloadBtnIsDisabled } = this.state;
    return (
      <div className='report-content-wrapper'>
        <div className='report-header'>
          <div className='report-text faq-text'>Reports</div>
          <button className='sync-btn' onClick={() => { if (window.confirm('Are you sure you wish to sync data?')) this.syncSheet() }}>
            Sync <img className="report-sync-icon" src={sync} alt='' />
          </button>
        </div>
        <div className='container-report-menu'>
          <button className='btn' name='clicked'
            onClick={this.reportFilterHandleChange}
          >
            Clicks Report
          </button>
          <button className='btn' name='chatReport'
            onClick={this.reportFilterHandleChange}
          >
            Chat Report
          </button>
          <button className='btn' name='issueReport'
            onClick={this.reportFilterHandleChange}
          >
            Issues Report
          </button>
          <button className='btn' name='answerReport '
            onClick={this.reportFilterHandleChange}
          >
            Answers Report
          </button>
        </div>
        <div className='report-filter-container'>
          <div className='report-filter'>
            <input className="inputBox"
              value={this.state.searchK}
              onChange={this.textChanged}
              placeholder="Enter token"
              onKeyDown={this._handleKeyDown}
            />
            <img className="clear-icon" onClick={this.clearFields} src={clear} style={{ display: this.state.searchK ? '' : "none" }} />
            <img className="report-serarch-icon" onClick={this.searchButton} src={serarchSvg} />
          </div>
          <button className='report-download-btn'
            onClick={this.downloadIntoExcle}
            disabled={downloadBtnIsDisabled ? downloadBtnIsDisabled : false}
          >
            <img className="report-download-icon" src={download} />
          </button>
        </div>
        {loading ? (
          <div className="loading-svg">
            <strong className='loader-heading'>Please Wait...</strong>
            <img src={loader} className="loader-img" />
          </div>

        ) : (
            <div>
              {reportData.length > 0 ? this.reportTable() :
                <div className='warning-container'>
                  <img className="warning-img" src={warningImg} />
                  <p>Data Not Found</p>
                </div>
              }
            </div>
          )}
        <div className="app-footer" >
          {showToast ? (
            <div className='report-show-toast-message'>
              <p>{message}</p>
              <img className="close-toast" src={closeSvg} onClick={this.closeToast}></img>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default Report;
